import { render, staticRenderFns } from "./GroupModal.vue?vue&type=template&id=d6cd97ba"
import script from "./GroupModal.vue?vue&type=script&lang=ts"
export * from "./GroupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports